module.exports = __webpack_public_path__ + "img/coquillages-en-ligne-boutrais-medium.668b21d5.png";